import { createContext } from 'react';

/**
 * @type {React.Context<{
 *  isOnline: boolean
 * }>}
 */
export const AppContext = createContext({ isOnline: true });
